export const MONTHLY_PENSION_1K: Record<string, number> = {
  '18': 42,
  '19': 46,
  '20': 50,
  '21': 54,
  '22': 59,
  '23': 64,
  '24': 70,
  '25': 76,
  '26': 82,
  '27': 90,
  '28': 97,
  '29': 106,
  '30': 116,
  '31': 126,
  '32': 138,
  '33': 151,
  '34': 165,
  '35': 181,
  '36': 198,
  '37': 218,
  '38': 240,
  '39': 264,
};

export const MONTHLY_PENSION_2K: Record<string, number> = {
  '18': 84,
  '19': 92,
  '20': 100,
  '21': 108,
  '22': 117,
  '23': 127,
  '24': 139,
  '25': 151,
  '26': 164,
  '27': 178,
  '28': 194,
  '29': 212,
  '30': 231,
  '31': 252,
  '32': 276,
  '33': 302,
  '34': 330,
  '35': 362,
  '36': 396,
  '37': 436,
  '38': 480,
  '39': 528,
};

export const MONTHLY_PENSION_3K: Record<string, number> = {
  '18': 126,
  '19': 138,
  '20': 150,
  '21': 162,
  '22': 177,
  '23': 192,
  '24': 208,
  '25': 226,
  '26': 246,
  '27': 268,
  '28': 292,
  '29': 318,
  '30': 347,
  '31': 379,
  '32': 414,
  '33': 453,
  '34': 495,
  '35': 543,
  '36': 594,
  '37': 654,
  '38': 720,
  '39': 792,
};

export const MONTHLY_PENSION_4K: Record<string, number> = {
  '18': 168,
  '19': 183,
  '20': 198,
  '21': 215,
  '22': 234,
  '23': 254,
  '24': 277,
  '25': 301,
  '26': 327,
  '27': 356,
  '28': 388,
  '29': 423,
  '30': 462,
  '31': 504,
  '32': 551,
  '33': 602,
  '34': 659,
  '35': 722,
  '36': 792,
  '37': 870,
  '38': 957,
  '39': 1054,
};

export const MONTHLY_PENSION_5K: Record<string, number> = {
  '18': 210,
  '19': 228,
  '20': 248,
  '21': 269,
  '22': 292,
  '23': 318,
  '24': 346,
  '25': 376,
  '26': 409,
  '27': 446,
  '28': 485,
  '29': 529,
  '30': 577,
  '31': 630,
  '32': 689,
  '33': 752,
  '34': 824,
  '35': 902,
  '36': 990,
  '37': 1087,
  '38': 1196,
  '39': 1318,
};
